module.exports = __webpack_public_path__ + "static/img/jjfa_hy.a11f7dfb.png";